export class DocumentManagment {

    static OPEN_CLASS: string = 'active';
    static CLOSE_CALSS: string ='close';

    protected static init() {
        document.addEventListener('DOMContentLoaded', DocumentManagment.onDocumentLoaded, false);
    }

    protected static onDocumentLoaded() {
        var accordenEntrys = document.getElementsByClassName("accordionTitle");
        for (let i = 0; i < accordenEntrys.length; i++) {
            let handle: Element = accordenEntrys[i];
            handle.addEventListener('click', (event: Event) => DocumentManagment.toggle(handle, event));
        }
    }



    protected static toggle(handle: Element, event?: Event) {
        handle.parentElement.classList.toggle(DocumentManagment.OPEN_CLASS);
        handle.parentElement.classList.toggle(DocumentManagment.CLOSE_CALSS);
    }

}